export const shouldRequireFaceRegistration = (
  imageUrl?: string | null,
): boolean => {
  if (typeof imageUrl !== "string") {
    return true;
  }

  return imageUrl.trim().length === 0;
};

export const getFaceImageValidationError = (
  file?: File | null,
): string | null => {
  if (!file) {
    return "Please choose an image before uploading.";
  }

  const allowedMimeTypes = ["image/png", "image/jpeg", "image/jpg"];
  const isAllowedType =
    allowedMimeTypes.includes(file.type) || /\.(png|jpe?g)$/i.test(file.name);

  if (!isAllowedType) {
    return "Only PNG, JPG, and JPEG images are allowed.";
  }

  if (file.size >= 20 * 1024 * 1024) {
    return "Image size must be less than 20 MB.";
  }

  return null;
};

export const validateCompressedProfileImage = (
  file?: File | null,
): string | null => {
  const baseErr = getFaceImageValidationError(file);
  if (baseErr) return baseErr;
  if (file && file.size > 1 * 1024 * 1024) {
    return "Image size must be less than 1 MB.";
  }
  return null;
};

